import { createSlice } from '@reduxjs/toolkit'

     

     
const initialState={ 
    code:undefined,
}

export const CodeSlice =  createSlice({
  name: 'code',
  initialState,
  reducers: {
  
    setCode: (state,action) => {     
       state.code=action.payload;  
    },


  },
})
export const {setCode}=CodeSlice.actions
export default CodeSlice.reducer